import React from "react";

import ClientRoutes from "Routes";
import "Style/global.scss";

const App = () => {
  return <ClientRoutes />;
};

export default App;
